if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        zoomHasOpened: false,
        zoomHasModel: Boolean(settings.defer_zoom_has_model),
        zoomIsMounting: false,
        zoomItems: [],
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        threejsVariantImageSource: '',
        _threejsVariantImageListener: null,
        init() {
          this._threejsVariantImageListener = (event) => {
            const variant = event.detail?.currentVariant;
            const source = variant?.featured_image?.src
              || variant?.featured_media?.preview_image?.src;
            if (!source) return;
            this.threejsVariantImageSource = source;
            this.syncThreejsVariantImages();
          };
          document.addEventListener(
            `eurus:product-card-variant-select:updated:${settings.section_id}`,
            this._threejsVariantImageListener
          );
        },
        _threejsImageUrl(source, width) {
          if (!source) return '';
          const normalizedSource = source.startsWith('//') ? `${window.location.protocol}${source}` : source;
          const url = new URL(normalizedSource, window.location.href);
          url.searchParams.set('width', width);
          return url.toString();
        },
        syncThreejsVariantImages() {
          if (!this.threejsVariantImageSource) return;
          document.querySelectorAll('[data-mio-threejs-variant-image]').forEach((image) => {
            if (image.dataset.mioThreejsVariantImage !== settings.section_id) return;
            const width = Number(image.dataset.mioImageWidth) || 150;
            image.src = this._threejsImageUrl(this.threejsVariantImageSource, width);
            image.removeAttribute('srcset');
          });
        },
        destroy() {
          if (!this._threejsVariantImageListener) return;
          document.removeEventListener(
            `eurus:product-card-variant-select:updated:${settings.section_id}`,
            this._threejsVariantImageListener
          );
          this._threejsVariantImageListener = null;
        },
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        _zoomImageUrl(source, width) {
          if (!source) return '';
          const url = new URL(source, window.location.origin);
          url.searchParams.set('width', width);
          return url.toString();
        },
        _buildDeferredZoom(position) {
          const gallery = document.getElementById(`x-product-${settings.section_id}`);
          if (!gallery) {
            this.zoomItems = [];
            return;
          }

          const slides = Array.from(
            gallery.querySelectorAll('.media-slide.media_active[data-type="image"]')
          ).filter((slide) => !slide.classList.contains('splide__slide--clone'));
          this.zoomItems = slides.map((slide) => {
            const image = slide.querySelector('img.image-detail');
            if (!image) return null;
            const source = image.getAttribute('src') || image.dataset.mioImg || '';
            const widths = [375, 450, 750, 900, 1100, 1500, 1780, 2000];
            return {
              alt: image.alt || '',
              height: Number(image.getAttribute('height')) || image.height,
              id: slide.dataset.mediaId,
              position: slide.dataset.zoomPosition,
              src: this._zoomImageUrl(source, 1200),
              srcset: image.getAttribute('srcset') || widths.map((width) => (
                `${this._zoomImageUrl(source, width)} ${width}w`
              )).join(', '),
              thumbnail: this._zoomImageUrl(source, 150),
              width: Number(image.getAttribute('width')) || image.width,
            };
          }).filter(Boolean);
        },
        _moveDeferredZoom(position, refresh = false) {
          const splideEl = document.getElementById(`media-gallery-${settings.section_id}`);
          if (!splideEl || !splideEl.splide) return false;
          if (refresh) {
            splideEl.splide.refresh();
            setTimeout(() => this._moveDeferredZoom(position), 0);
            return true;
          }

          const slides = Array.from(splideEl.querySelector('.splide__list').children)
            .filter((slide) => slide.classList.contains('splide__slide'));
          const selected = slides.findIndex((slide) => slide.dataset.zoomPosition == position);
          splideEl.splide.go(selected >= 0 ? selected : 0);
          this._setDeferredThumbnail(selected >= 0 ? selected : 0);
          return true;
        },
        _setDeferredThumbnail(index) {
          const root = document.getElementById(`x-zoom-thumbnail-${settings.section_id}`);
          if (!root) return;
          const thumbnails = Array.from(root.getElementsByClassName('x-thumbnail'));
          thumbnails.forEach((thumbnail, thumbnailIndex) => {
            thumbnail.classList.toggle('opacity-30', thumbnailIndex !== Number(index));
          });
        },
        _deferredZoomConfig() {
          const config = {
            speed: 1000,
            pagination: false,
            mediaQuery: 'min',
            updateOnMove: 'true',
            noDrag: 'model-viewer, .threejs-viewer-container canvas, .threejs-viewer-container input[type=range]',
            thumbs: `x-zoom-thumbnail-${settings.section_id}`,
            thumbs_direction: 'horizontal',
            breakpoints: {
              300: { perPage: 1, perMove: 1 },
              768: { perPage: 1, perMove: 1 },
              1024: { perPage: 1, perMove: 1 },
            },
            classes: { arrows: 'hidden' },
            events: [{
              event: 'ready',
              callback: () => {
                this.zoomIsMounting = false;
                document.dispatchEvent(new CustomEvent(`eurus:zoom-image-ready:${settings.section_id}`));
              },
            }, {
              event: 'move',
              callback: (index) => this._setDeferredThumbnail(index),
            }],
          };
          if (settings.defer_zoom_rtl) config.direction = 'rtl';
          return config;
        },
        _syncDeferredZoom(position) {
          const readyEvent = `eurus:zoom-image-ready:${settings.section_id}`;
          const onReady = () => this._moveDeferredZoom(position);
          document.addEventListener(readyEvent, onReady, { once: true });
          requestAnimationFrame(() => requestAnimationFrame(() => {
            this.syncThreejsVariantImages();
            if (this._moveDeferredZoom(position, true)) {
              document.removeEventListener(readyEvent, onReady);
              return;
            }

            const splideEl = document.getElementById(`media-gallery-${settings.section_id}`);
            if (splideEl && !this.zoomIsMounting) {
              this.zoomIsMounting = true;
              Alpine.store('xSplide').load(splideEl, this._deferredZoomConfig());
            }
          }));
        },
        zoomOpen(position, isSplide) {
          if (settings.defer_zoom_gallery) {
            this._buildDeferredZoom(position);
            if (!this.zoomItems.length) return;
            this.zoomHasOpened = true;
            this.zoomIsOpen = true;
            Alpine.store('xPopup').open = true;
            Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
            this._syncDeferredZoom(position);
            return;
          }
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            this.syncThreejsVariantImages();
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}
